// extracted by mini-css-extract-plugin
export default {"tableAvatar":"excluded_tableAvatar__97qYM","tableAvatar__img":"excluded_tableAvatar__img__n7tTY","rank":"excluded_rank__qPUuw"};